var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-title"},[_c('div',{staticClass:"text"},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.title)+" ")]})],2),_c('img',{staticClass:"image",attrs:{"src":require("../imgs/Group 291.png"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }